export default "__VITE_ASSET__BzzMBJNI__"